import { render, staticRenderFns } from "./BradenTask.vue?vue&type=template&id=035972f7&scoped=true&"
import script from "./BradenTask.vue?vue&type=script&lang=js&"
export * from "./BradenTask.vue?vue&type=script&lang=js&"
import style0 from "./BradenTask.vue?vue&type=style&index=0&id=035972f7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035972f7",
  null
  
)

export default component.exports